import ConversionResult from '../entities/conversionResult.js';

class ConversionResultFormatter{
    stringify (value, thousandSeparator, decimalSeparator, fractionalDigitsPadding){
        return ConversionResult.stringify(value, thousandSeparator, decimalSeparator, fractionalDigitsPadding);
    }

    stringifyUnitSymbol(stringified, symbolPrefix, symbolSuffix, unit, unitSymbolIndex){
        return ConversionResult.stringifyUnitSymbol(stringified, symbolPrefix, symbolSuffix, unit, unitSymbolIndex);
    }
}

export default ConversionResultFormatter;